import React, { useState, useEffect } from 'react';
import ContenedorDeAvance from './ContenedorDeAvance';
import DetallesActividadGuardada from './DetallesActividadGuardada';

const ListaActividadesGuardadas = (p) => {
    const lista = p.lista;
    const historial = p.historial ?? false; //determina si se esta en modo hisorial para no permitir el registro de actividades
    const keys = [
        { key: "labor", text: "Labor", class: "wpx-250" },
        { key: "area", text: "Área" },
        { key: "bloque", text: "Flor - Variedad - Color", class: "text-red3 upper text" },
        { key: "rancho", text: "Rancho", nl: "N/D" },
        { key: "valvula", text: "Valvula", nl: "N/D" },
        { key: "cama_inicio", text: "Cama fin", nl: "N/D", class: "text-xs" },
        { key: "cama_fin", text: "Cama inicio", nl: "N/D", class: "text-xs" },
        { key: "semana", text: "Semana", nl: "N/D", class: "text-bold" }
    ];
    const [detalles, setdetalles] = useState(null);
    const abrirDetalles = (data) => setdetalles(data);
    var baseKey = Math.floor(Math.random() * 100000) + 1;
    useEffect(() => {

    }, []);
    const generarCadenaAleatoria = () => {
        const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let cadena = '';
        let len = Math.floor(Math.random() * caracteres.length) + 10;
        for (let i = 0; i < len; i++) {
            const randomIndex = Math.floor(Math.random() * caracteres.length);
            cadena += caracteres[randomIndex];
        }
        return cadena;
    };

    const getKey = () => {
        baseKey++;
        return baseKey + generarCadenaAleatoria();
    }

    const cerrarPadre = () => setdetalles(null);

    return (

        <table className='table table-sm table-striped text-s'>
            <thead>
                <tr>
                    {keys.map((k, i) => <th key={getKey()} scope='col' className='text-m nowrap'>{k.text}</th>)}
                </tr>
            </thead>
            <tbody>
                {
                    lista.map((item, index) =>
                        <React.Fragment key={getKey()}>
                            <tr key={"row " + index} className='pointer' onClick={() => { abrirDetalles(detalles && detalles.id === item.id ? null : item) }}>
                                {keys.map((k, i) => <td key={getKey()} scope='col' className={`nowrap ${k.class ?? ""} ${detalles && detalles.id == item.id ? 'bg-blue-soft' : ''}`}>
                                    {k.key === 'labor' ? (<ContenedorDeAvance data={item} />) : item[k.key] ?? k.nl}
                                </td>)}
                            </tr>
                            {detalles && detalles.id === item.id && <tr className='text-center'>
                                <td colSpan={keys.length}>
                                    <DetallesActividadGuardada data={detalles} registrar={p.registrar} historial={historial} editar={p.editar} cerrarPadre={cerrarPadre} />
                                </td>
                            </tr>}
                        </React.Fragment>

                    )
                }
            </tbody>
        </table>
    )
}

export default ListaActividadesGuardadas;